const ROOT_SELECTORS = ['.jdgm-carousel-wrapper', '.jdgm-carousel', '.jdgm-testimonials-carousel'];
const SWIPE_THRESHOLD = 40;

function getArrowButtons(root) {
  const explicitPrev = root.querySelector(
    [
      '[aria-label*="previous" i]',
      '[aria-label*="prev" i]',
      '[class*="previous"]',
      '[class*="prev"]',
      '[data-direction="previous"]',
      '[data-direction="prev"]',
    ].join(', ')
  );

  const explicitNext = root.querySelector(
    [
      '[aria-label*="next" i]',
      '[class*="next"]',
      '[data-direction="next"]',
    ].join(', ')
  );

  if (explicitPrev && explicitNext) {
    return { prev: explicitPrev, next: explicitNext };
  }

  const arrowContainer = root.querySelector(
    [
      '[class*="arrow"]',
      '[class*="nav"]',
      '[class*="control"]',
      '[class*="pagination"]',
    ].join(', ')
  );

  if (!arrowContainer) {
    return { prev: null, next: null };
  }

  const buttons = [...arrowContainer.querySelectorAll('button, [role="button"]')].filter(
    (button) => !button.hasAttribute('disabled') && button.getAttribute('aria-hidden') !== 'true'
  );

  if (buttons.length < 2) {
    return { prev: null, next: null };
  }

  return {
    prev: buttons[0],
    next: buttons[buttons.length - 1],
  };
}

function bindSwipe(root) {
  if (!(root instanceof HTMLElement) || root.dataset.jdgmSwipeBound === 'true') {
    return;
  }

  root.dataset.jdgmSwipeBound = 'true';

  let startX = 0;
  let startY = 0;
  let tracking = false;

  root.addEventListener(
    'touchstart',
    (event) => {
      if (event.touches.length !== 1) {
        tracking = false;
        return;
      }

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
    },
    { passive: true }
  );

  root.addEventListener(
    'touchend',
    (event) => {
      if (!tracking || event.changedTouches.length !== 1) {
        tracking = false;
        return;
      }

      const deltaX = event.changedTouches[0].clientX - startX;
      const deltaY = event.changedTouches[0].clientY - startY;
      tracking = false;

      if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) <= Math.abs(deltaY)) {
        return;
      }

      const { prev, next } = getArrowButtons(root);
      if (!prev || !next) {
        return;
      }

      if (deltaX < 0) {
        next.click();
      } else {
        prev.click();
      }
    },
    { passive: true }
  );
}

function bindAll() {
  for (const selector of ROOT_SELECTORS) {
    for (const root of document.querySelectorAll(selector)) {
      bindSwipe(root);
    }
  }
}

bindAll();

const observer = new MutationObserver(() => bindAll());
observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});